import { isAfter, isValid, parse, startOfToday, subYears } from 'date-fns';
import type { z } from 'zod';

import i18n from '@/lib/i18n';

type DateOfBirthRefinement = { day: string; month: string; year: string };

const MINIMUM_AGE = 18;

export const dateOfBirthRefinement = (data: DateOfBirthRefinement, context: z.RefinementCtx) => {
  if (!data.day || !data.month || !data.year) return;

  const date = parse(`${data.year}-${data.month}-${data.day}`, 'yyyy-M-d', new Date());

  if (!isValid(date)) {
    context.addIssue({
      code: 'custom',
      message: i18n.t('personalInformation.errors.dateOfBirth'),
      path: [],
    });
  }

  if (isAfter(date, subYears(startOfToday(), MINIMUM_AGE))) {
    context.addIssue({
      code: 'custom',
      message: i18n.t('personalInformation.errors.dateOfBirthAgeRestriction'),
      path: [],
    });
  }
};
